import React from "react";

const StatisticsModal = ({ infoStatistics }) => {
  let tableHorseStatistic = [],
    tableHorseStatisticCareer = [],
    horseStatistics = infoStatistics.HorseStatistics;
  if (horseStatistics) {
    tableHorseStatistic.push(
      <tr key={"statistics" + infoStatistics.EntryID}>
        <td style={{ textAlign: "center" }}>
          {horseStatistics.Statistics.Starts}
        </td>
        <td style={{ textAlign: "center" }}>
          {horseStatistics.Statistics.Firsts}
        </td>
        <td style={{ textAlign: "center" }}>
          {horseStatistics.Statistics.Seconds}
        </td>
        <td style={{ textAlign: "center" }}>
          {horseStatistics.Statistics.Thirds}
        </td>
        <td style={{ textAlign: "center" }}>
          {horseStatistics.Statistics.Earnings}
        </td>
      </tr>
    );

    tableHorseStatisticCareer.push(
      <tr key={"careerStatistics" + infoStatistics.EntryID}>
        <td style={{ textAlign: "center" }}>
          {horseStatistics.CareerStatistics.Starts}
        </td>
        <td style={{ textAlign: "center" }}>
          {horseStatistics.CareerStatistics.Firsts}
        </td>
        <td style={{ textAlign: "center" }}>
          {horseStatistics.CareerStatistics.Seconds}
        </td>
        <td style={{ textAlign: "center" }}>
          {horseStatistics.CareerStatistics.Thirds}
        </td>
        <td style={{ textAlign: "center" }}>
          {horseStatistics.CareerStatistics.Earnings}
        </td>
      </tr>
    );
  }

  var entryNum,
    entryName,
    riderName,
    trainerName,
    ownerName,
    pedigrees,
    breeders;
  if (infoStatistics) {
    entryNum = infoStatistics.EntryNum;
    entryName = infoStatistics.EntryName;
    riderName = infoStatistics.RiderName;
    trainerName = infoStatistics.TrainerName;
    ownerName = infoStatistics.OwnerName;
    pedigrees = infoStatistics.Pedigrees;
    breeders = infoStatistics.Breeders;
  }

  return (
    <>
      <div
        className="modal fade"
        id="entryStatisticsModal"
        role="dialog"
        tabIndex="-1"
        aria-labelledby="entryStatisticsModal"
        aria-hidden="false"
        data-keyboard="false"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-md" role="document">
          <div className="modal-content">
            <div className="modal-header headerModals">
              <h5 className="modal-title" id="modalSta">
                Horse Statistics
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div
                style={{
                  textAlign: "center",
                }}
              >
                <h5 className="title">
                  {entryNum} {entryName}
                </h5>
              </div>

              <div className="row">
                <div className="col-sm-12">
                  <div className="row col-sm-12">
                    <h6
                      className=""
                      style={{
                        width: "80px",
                        fontWeight: "bold",
                      }}
                    >
                      Rider:
                    </h6>
                    <label>{riderName}</label>
                  </div>
                  <div className="row col-sm-12">
                    <h6
                      className=""
                      style={{
                        width: "80px",
                        fontWeight: "bold",
                      }}
                    >
                      Trainer:
                    </h6>
                    <label>{trainerName}</label>
                  </div>
                  <div className="row col-sm-12">
                    <h6
                      className=""
                      style={{
                        width: "80px",
                        fontWeight: "bold",
                      }}
                    >
                      Owner:
                    </h6>

                    <label>{ownerName}</label>
                  </div>
                  <div className="row col-sm-12">
                    <h6
                      className=""
                      style={{
                        width: "80px",
                        fontWeight: "bold",
                      }}
                    >
                      Pedigrees:
                    </h6>

                    <label>{pedigrees}</label>
                  </div>
                  <div className="row col-sm-12">
                    <h6
                      className=""
                      style={{
                        width: "80px",
                        fontWeight: "bold",
                      }}
                    >
                      Breeders:
                    </h6>
                    <label>{breeders}</label>
                  </div>
                  <div
                    className="mt-3"
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                    }}
                  >
                    <p>STATISTICS</p>
                  </div>
                  <table className="table table-striped table-sm">
                    <thead className="thead-dark">
                      <tr className="text-center header ">
                        <th>Starts</th>
                        <th>Firsts</th>
                        <th>Seconds</th>
                        <th>Thirds</th>
                        <th>Earnings</th>
                      </tr>
                    </thead>
                    <tbody className="table-sm">{tableHorseStatistic}</tbody>
                  </table>
                  <div
                    className="mt-3 "
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                    }}
                  >
                    <p>CAREER STATISTICS</p>
                  </div>

                  <table className="table table-striped table-sm">
                    <thead className="thead-dark">
                      <tr className="text-center header">
                        <th>Starts</th>
                        <th>Firsts</th>
                        <th>Seconds</th>
                        <th>Thirds</th>
                        <th>Earnings</th>
                      </tr>
                    </thead>
                    <tbody className="table-sm">
                      {tableHorseStatisticCareer}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StatisticsModal;
